module.exports = __webpack_public_path__ + "static/media/031-cloud.87b82442.svg";